export default __webpack_public_path__ + "static/media/contact-map-marker-text.26f13420.svg";